/* KOLI ディスカウントコード欄（カートページ）
   仕組み：Cart AJAX API /cart/update.js の discount パラメータ（2025-05追加）で適用。
   - 適用可否はレスポンス discount_codes[].applicable で判定（無効コードはカートに残留するため掃除が必要）
   - 適用済みコードの一覧は Liquid では引けない（cart.discount_codes は null）ため /cart.js から描画
   - 成功時は Dawn と同じ Section Rendering（sections パラメータ）で小計・明細を差し替える */
(() => {
  if (customElements.get('koli-discount')) return;

  const escapeHtml = (str) =>
    String(str).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));

  class KoliDiscount extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.koli-discount__input');
      this.applyButton = this.querySelector('.koli-discount__apply');
      this.message = this.querySelector('.koli-discount__message');
      this.chips = this.querySelector('.koli-discount__chips');
      this.appliedCodes = [];

      this.applyButton.addEventListener('click', () => this.apply());
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.apply();
        }
      });
      this.chips.addEventListener('click', (event) => {
        const button = event.target.closest('[data-code]');
        if (button) this.remove(button.dataset.code);
      });

      this.loadAppliedCodes();
    }

    async loadAppliedCodes() {
      try {
        const response = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
        const cart = await response.json();
        this.appliedCodes = (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
        this.renderChips();
      } catch {
        this.appliedCodes = [];
      }
    }

    renderChips() {
      this.chips.innerHTML = this.appliedCodes
        .map(
          (code) => `<li class="koli-discount__chip">
            <span>${escapeHtml(code)}</span>
            <button type="button" data-code="${escapeHtml(code)}" aria-label="ディスカウントコード ${escapeHtml(code)} を削除">✕</button>
          </li>`
        )
        .join('');
      this.chips.hidden = this.appliedCodes.length === 0;
    }

    getSectionsToRender() {
      return [
        { id: 'main-cart-items', selector: '.js-contents' },
        { id: 'main-cart-footer', selector: '.js-contents' },
      ]
        .map((section) => {
          const element = document.getElementById(section.id);
          return element ? { ...section, section: element.dataset.id } : null;
        })
        .filter(Boolean);
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    async postDiscounts(codes, sections) {
      const body = { discount: codes.join(',') };
      if (sections) {
        body.sections = sections.map((section) => section.section);
        body.sections_url = window.location.pathname;
      }
      const response = await fetch(routes.cart_update_url, { ...fetchConfig(), body: JSON.stringify(body) });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return response.json();
    }

    renderSections(state, sections) {
      sections.forEach((section) => {
        const container = document.getElementById(section.id);
        const target = container.querySelector(section.selector) || container;
        target.innerHTML = this.getSectionInnerHTML(state.sections[section.section], section.selector);
      });
      // .js-contents の差し替えで新しい koli-discount インスタンスが connect され、チップは再描画される
    }

    setLoading(isLoading) {
      this.applyButton.disabled = isLoading;
      this.input.disabled = isLoading;
      this.classList.toggle('koli-discount--loading', isLoading);
    }

    showMessage(text) {
      this.message.textContent = text;
      this.message.hidden = !text;
    }

    async apply() {
      const code = this.input.value.trim();
      if (!code) {
        this.input.focus();
        return;
      }
      this.showMessage('');
      this.setLoading(true);
      const sections = this.getSectionsToRender();
      try {
        const state = await this.postDiscounts([...this.appliedCodes, code], sections);
        const entered = (state.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
        if (entered && entered.applicable) {
          this.renderSections(state, sections);
          return; // このインスタンスは破棄済み。後続処理はしない
        }
        // 無効コードはカート状態に残るので、元の適用済みコードだけに戻す
        await this.postDiscounts(this.appliedCodes);
        this.showMessage('このコードは利用できません。入力内容をご確認ください。');
        this.input.select();
      } catch {
        this.showMessage('適用に失敗しました。時間をおいてもう一度お試しください。');
      } finally {
        if (this.isConnected) this.setLoading(false);
      }
    }

    async remove(code) {
      this.setLoading(true);
      const sections = this.getSectionsToRender();
      try {
        const remaining = this.appliedCodes.filter((c) => c !== code);
        const state = await this.postDiscounts(remaining, sections);
        this.renderSections(state, sections);
      } catch {
        this.showMessage('解除に失敗しました。時間をおいてもう一度お試しください。');
        if (this.isConnected) this.setLoading(false);
      }
    }
  }

  customElements.define('koli-discount', KoliDiscount);
})();
